import { atom, getDefaultStore, useAtomValue } from 'jotai';

const profilesTableEditingProfileNameAtom = atom<number | null>(null);

const useProfilesTableEditingProfileName = (): number | null => useAtomValue(profilesTableEditingProfileNameAtom);
export const useIsEditingProfileName = (profileIdx: number): boolean => useProfilesTableEditingProfileName() === profileIdx;

export const setProfilesTableEditingProfileName = (newEditingProfileNameIdx: number | null): void => getDefaultStore()
  .set(profilesTableEditingProfileNameAtom, newEditingProfileNameIdx);
